{
  "loading": "Notiek ielāde...",
  "loadingMore": "Tiek ielādēts vēl..."
}
